import { useCallback, useState } from 'react'

export const useColumnCollapse = () => {
  const [collapseState, setCollapseState] = useState<Record<string, boolean>>(
    {}
  )

  const toggleCollapse = useCallback((columnId: string) => {
    setCollapseState(prev => ({ ...prev, [columnId]: !prev[columnId] }))
  }, [])

  const isCollapsed = useCallback(
    (columnId: string) => collapseState[columnId] ?? false,
    [collapseState]
  )

  return { collapseState, toggleCollapse, isCollapsed }
}
